import Reflux from 'reflux';
import AuthActions from '../AuthActions';
import http from '../../services/fetch';
import ErrorHandlerStore from './ErrorHandlerStore';
import AlertActions from '../AlertActions';
import history from 'react-router/lib/hashHistory';
import dateformat from 'dateformat';

var AuthStore = Reflux.createStore({
    init: function() {
        this.listenToMany(AuthActions);
    },

    /**
     * Perfermos a registration of a new user
     *
     * @param {Object} User data
     * @return {void}
     */
    register: function(user) {
        user.cliente.email = user.email;
        http.post('users', user)
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.login({username: user.email, password: user.password});
        });
    },

    /**
     * Perfermos an editing of a user
     *
     * @param {Object} user data
     * @return {void}
     */
    putUser: function(user) {
        user.email = user.cliente.email;
        const token = localStorage.getItem('access_token');
        http.put('user', user, token)
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.trigger('putUser', json);
        });
    },

    /**
     * Perfermos a login request to the oauth server
     * to obtain an acess_token
     *
     * @param {Object} credentials Username and password.
     * @return {void}
     */
    login: function(credentials) {
        const body = {
            ...credentials,
            grant_type: 'password',
            client_id: '12345',
            client_secret: 'neron'
        };

        http.post('oauth/access_token', body)
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            localStorage.setItem('access_token', json.access_token);
            this.trigger('login_success');
        });
    },

    /**
     * Verifies if there is an access_token, tries to obtain user data,
     * if it fails, redirect to Login page
     *
     * @param {Object} nextState Proviced by react-router
     * @param {function} replace Function to go to another route
     * @return {void}
     */
    checkLogin: function(nextState, replace) {
        const token = localStorage.getItem('access_token');

        if (!token) {
            history.push('/login');
        }

        else {
            http.get('user', token)
            .then((ErrorHandlerStore.checkForErrors))
            .then((json) => {
                if (json === 'denied')
                    history.push('/login');
                else {
                    this.user = json.user;
                    this.extras = {};
                    this.extras.servicios = json.servicios;
                    this.extras.tipospago = json.tipospago;
                    this.getUser();
                    this.trigger('auth_success', this.user);
                }

            });
        }

    },

    /**
     * Makes a POST request to create a new Pago for the current user
     *
     * @param {Pago} pago The pago being sent
     * @return {Object} cliente
     */
    newPago: function(pago) {
        let body = new FormData();
        
        body.append('tipo_pago_id', pago.tipo_pago_id);
        body.append('pedido_id', pago.pedido_id);
        body.append('fecha', dateformat(pago.fecha, 'yyyy-mm-dd'));
        body.append('monto', pago.monto);
        body.append('numero_documento', pago.numero_documento );
        body.append('soporte', pago.soporte);

        http.postWithFile('suscripcion/pago', body, localStorage.getItem('access_token'))
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.checkLogin();
            this.trigger('createdPago', json.pago);
        });

    },

    /**
     * Makes a POST request to make a new suscription
     *
     * @param {string} servicio The id of the servicio being requested
     * 
     */
    solicitar: function(servicio) {
        const token = localStorage.getItem('access_token');

        const body = {
            inventario_id: servicio
        };

        http.post('suscripcion/pedido', body, localStorage.getItem('access_token'))
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.checkLogin();
        });

    },

    /**
     * Get the cliente of the logged user (sync)
     *
     * @return {Object} cliente
     */
    getCliente: function() {
        return this.user ? this.user.cliente : null;
    },

    /**
     * Triggers an event sending the current logged user;
     *
     * @return {Object} user
     */
    getUser: function() {
        this.trigger('getUser', this.user, this.extras);
    },

    /**
     * Gets the totals of all operations in the app
     *
     * @return {void}
     */
    getTotals: function() {
        http.get('totals', localStorage.getItem('access_token'))
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.trigger('getTotals', json);
        });
    },

    /**
     * Performs a put request to update correaltivos
     *
     * @param {Object} nextState Proviced by react-router
     * @param {function} replace Function to go to another route
     * @return {void}
     */
    updateCorrelativos: function(body) {
        const token = localStorage.getItem('access_token');

        http.put('/user/correlativos/edit', body,  token)
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {

            AuthActions.checkLogin();
            AlertActions.alert('open', 'Correlativos Modificados', 'Usted ha modificado sus correlativos correctamente');
        });

    },

});

export default AuthStore;



/** WEBPACK FOOTER **
 ** ./app-react/reflux/stores/AuthStore.js
 **/